import { ChannelListProviderInterface } from 'SendbirdUIKitGlobal';

export const getIsChannelExisting = (channelListState: ChannelListProviderInterface, channelId: string | null) =>
  !channelListState.loading && channelListState?.allChannels?.some(({ url }) => url === channelId);
